import { Helpers } from '../../helpers';
import { IFormationTop } from '../../interfaces/iformation-top';
import { Area } from '../area';
import { ProjectDrillingParametersFormationTop } from '../project-drilling-parameters-formation-top';
import { TargetFormation } from '../target-formation';

export class FormationTopBase {
  FormationTopId: number;
  AreaId: number | null;
  KBTVD: number | null;
  TargetFormationId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectDrillingParametersFormationTops_FormationTop?: Array<ProjectDrillingParametersFormationTop> | null;
  Area?: Area;
  TargetFormation?: TargetFormation;

  constructor(item?: IFormationTop) {
    if (item) {

      this.FormationTopId = item.FormationTopId;
      this.AreaId = item.AreaId;
      this.KBTVD = item.KBTVD;
      this.TargetFormationId = item.TargetFormationId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectDrillingParametersFormationTops_FormationTop = Helpers.createClassArray(ProjectDrillingParametersFormationTop, item.ProjectDrillingParametersFormationTops_FormationTop);
      this.Area = new Area(item.Area);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
    }
  }
}